export default __webpack_public_path__ + "static/media/img_2.95e090a4.JPG";